<template>
  <div>
    <h1>Add Users</h1>
    <v-form @submit.prevent="AddUser()">
      <v-container grid-list-xl fluid justify-center align-center>
        <v-card style="padding:5%;">
          <v-layout justify-center align-center column>
            <v-flex xs6 md5>
              <v-text-field
                :rules="rules.required"
                v-model="firstName"
                name="firstName"
                label="First Name"></v-text-field>

              <v-text-field v-model="lastName" name="lastName" label="Last Name"></v-text-field>
                <v-text-field v-model="email" name="email" label="Email"></v-text-field>
            </v-flex>
            <v-flex xs6 md4>
              <v-text-field label="School" v-model="school" name="school"></v-text-field>
            </v-flex>

          </v-layout>
<v-container>

</v-container>
          <v-layout justify-center>
            <v-flex xs1 md1>
              <v-text-field
                      label="Age"

                      class="centered-input"
                      v-model="age"
                      name="age"></v-text-field>
              <v-text-field label="Price" v-model="price" name="price"></v-text-field>
            </v-flex>
          </v-layout>
          <v-btn type="submit">Submit</v-btn>
          <v-btn v-on:click="Clear()">Clear</v-btn>
        </v-card>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import db from "./../database/";
import firebase from "firebase";
export default {
  name: "UserAdder",
  data() {
    return {
      firstName: "Cyndi",
      lastName: "Marshall",
      points: 0,
      age: "",
      price: "",
        email:"",
        password:"",

      school: "",
      rules: {
        required: [value => !!value || "Required"]
      }
    };
  },

  firestore() {
    return {
      users: db.collection("UsersDev")
    };
  },
  methods: {
      AddUser: function () {
          console.log("Adding User");
          if (this.email == "") {
              console.log("No email entered, will create one.")
              this.email = this.firstName + "." + this.lastName + "@NurtureAcademy.com";
              console.log("Email is now: " + this.email);
          }
          if (this.password == "") {
              console.log("no password chosen, creating password...");
              this.password = "nopassword";
          }
          this.CreateUserAuthentication();

      },

      CreateUserAuthentication(){
self = this;
          firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
    function(createdUser){
        console.log("Successfully created authentication..");
        self.CreateUserDatabase(createdUser.user.uid);
    })
    .catch(function (error) {
              // Handle Errors here.
              var errorCode = error.code;
              var errorMessage = error.message;
              self.$toasted.show(errorMessage);
          });
      },
      CreateUserDatabase(id){
          if(id==null || id==""){
              id="something";
          }
          this.$firestore.users.doc(id).set({
            firstName: this.firstName,
            lastName: this.lastName,
              email: this.email,
            age: this.age,
            school: this.school,
            price: this.price
          });
          console.log("Successfully added user info to database.");
      },
    Clear() {
      this.firstName = "";
      this.lastName = "";

      this.age = "";

      this.school = "";
    }
  }
};
</script>

<style>
.centered-input input {
  text-align: center;
}
</style>

